module.exports = __webpack_public_path__ + "img/public/SiteIcons/instantIcon.svg?e8b6911b";